var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSterlingReviewOperationalBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 180",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6B9080",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 58,
    x2: 72,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 126,
    x2: 72,
    y2: 136
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 92,
    x2: 28,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 92,
    x2: 116,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 68,
    x2: 40,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 116,
    x2: 104,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 68,
    x2: 104,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 116,
    x2: 40,
    y2: 124
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#6B9080",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 78,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 78,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 52,
    x2: 128,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 104,
    x2: 128,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 78,
    x2: 94,
    y2: 78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 78,
    x2: 162,
    y2: 78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 60,
    x2: 104,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 96,
    x2: 152,
    y2: 102
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 60,
    x2: 152,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 96,
    x2: 104,
    y2: 102
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSterlingReviewOperationalBg);
export default __webpack_public_path__ + "static/media/sterling-review-operational-bg.b7e3581b4d6dfd8eca95b5b081bbb952.svg";
export { ForwardRef as ReactComponent };